import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class ChangePassword extends React.Component {

  state = {
    newPassword: '',
    confirmPassword: ''
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  changePassword = () => {
    const { newPassword, confirmPassword } = this.state;
    const { firebase, handleClose } = this.props;

    if (!newPassword || !confirmPassword) {
      this.setState({ error: 'Please enter New Password and Confirm Password' });
      return
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: 'New Password and Confirm Password are not same' });
      return
    }

    firebase.auth().currentUser.updatePassword(newPassword).then((data) => {
      this.setState({ success: true });
      setTimeout(() => {
        handleClose();
        this.setState({ success: false, newPassword: '', confirmPassword: '', error: '' });
      }, 1000)
    }).catch((err) => {
      this.setState({ error: err.message });
    });

  }

  render() {
    const { open, handleClose } = this.props;
    const { newPassword, confirmPassword, error, success } = this.state;

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth
      >
        <DialogTitle id="scroll-dialog-title">Change Password</DialogTitle>
        <DialogContent>
          <form>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="title">Enter New Password</InputLabel>
              <Input
                onChange={this.handleChange}
                value={newPassword}
                id="newPassword" name="newPassword" type="password" />
            </FormControl>

            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="title">Confirm Password</InputLabel>
              <Input
                onChange={this.handleChange}
                value={confirmPassword}
                id="confirmPassword" name="confirmPassword" type="password" />
            </FormControl>

            {success && <Alert severity="success">Your Password successfully changed.</Alert>}


            {!success && error ? <div>  <br /> <Typography component="p" color="error" align="center"> {error}</Typography> </div> : null}

          </form>
        </DialogContent>
        {!success &&
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
        </Button>
            <Button onClick={() => { this.changePassword() }} color="primary">
              Update
            </Button>
          </DialogActions>}
      </Dialog>
    )
  }
}

export default ChangePassword;
